import {
  IDecodedToken,
  ILoginResponse,
  IPermission,
} from '@inshuwa-client/models';
import { getPermissions } from './auth-storage';
import { JwtHelperService } from '@auth0/angular-jwt';
import { sessionStore } from './session-store';

type Token = Record<string, any>;
export const GetDecodedToken = (): IDecodedToken | null => {
  const stored = sessionStore.getItem('token');
  if (!stored) return null;

  const token: ILoginResponse = JSON.parse(stored);

  const decodedToken = new JwtHelperService().decodeToken(
    token.accessToken,
  )! as Token;

  return decodedToken as IDecodedToken;
};

export const GetUserPermission = () => {
  const permission = getPermissions();
  return permission as unknown as IPermission;
};
